import React, { Component } from 'react';
import { Icon, Segment, List, Divider } from 'semantic-ui-react';
import * as GA from 'react-ga';

class Footer extends Component
{
	handleTwitter()
	{
		GA.event({
			category: 'twitter_link',
			action: 'clicked',
			label: 'clicked on twitter link'
		});

		window.open('http://twitter.com/captivategames', '_blank');
	}

	handleFacebook()
	{
		GA.event({
			category: 'facebook_link',
			action: 'clicked',
			label: 'clicked on facebook link'
		});

		window.open('https://fb.me/captivategames', '_blank');
	}

	render()
	{
		return (
			<div className='ui vertical footer'>
				<Segment className={this.props.bgColor} basic padded='very' textAlign='center'>
					<Icon fitted name='copyright' /> 2017 Captivate Games Incorporated.
					&nbsp;<Icon fitted name='power' />
					&nbsp;Founded in 2017.
					<Divider hidden />
					<List horizontal>
						<List.Item>
							<a><List.Icon name='twitter' size='big' className={this.props.bgColor} onClick={this.handleTwitter}/></a>
						</List.Item>
						<List.Item>
							<a><List.Icon name='facebook' size='big' className={this.props.bgColor} onClick={this.handleFacebook}/></a>
						</List.Item>
					</List>
				</Segment>
			</div>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js